import api from './index'
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios({
    url: '/api/auth/login',
    method: 'post',
    data: parameter
  })
}
// 获取验证吗
export function getShop(parameter) {
  return axios({
    url: '/api/frontend/phoneCode',
    method: 'post',
    data: parameter
  })
}
// 忘记密码
export function getForget(parameter) {
  return axios({
    url: '/api/auth/forgetPassword',
    method: 'post',
    data: parameter
  })
}
// 注册登录
export function getReg(parameter) {
  return axios({
    url: '/api/auth/register',
    method: 'post',
    data: parameter
  })
}
export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo(params) {
  return axios({
    url: '/distribution/user',
    method: 'get',
    params: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCurrentUserNav(token) {
  return axios({
    url: '/user/nav',
    method: 'get'
  })
}

// 是否要人机验证
export function getMachineVerify() {
  return axios({
    url: '/frontend/systemConfig/skipManMachineVerify',
    method: 'GET'
  })
}

export function logout() {
  return axios({
    url: '/api/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 获取当前用户群组余额
export function getGroupBalance() {
  return axios({
    url: '/distribution/user/getGroupBalance',
    method: 'GET'
  })
}

// 获取动态路由表
export function getRoutes() {
  return axios({
    url: '/distribution/user/getPermissions',
    method: 'GET'
  })
}
//

// 注册来源判断
export function setSession(params) {
  return axios({
    url: '/api/auth/setSession',
    method: 'GET',
    params: params
  })
}

// 获取邮箱验证码
export function getEmailCode(data) {
  return axios({
    url: '/api/frontend/emailCode',
    method: 'POST',
    data: data
  })
}

// 谷歌登录
export function googleLogin() {
  return axios({
    url: 'api/auth/google',
    method: 'GET'
  })
}

// 设置Referer
export function setReferer(data) {
  return axios({
    url: '/distribution/user/setReferer',
    method: 'POST',
    data: data
  })
}

export function getSystemNoticePolling(params) {
  return axios({
    url: '/distribution/systemNotice/polling',
    method: 'GET',
    params: params
  })
}
// 我的收藏数量
export function getCollectNum(params) {
  return axios({
    url: '/distribution/userBasicProductCategory/getCollectNum',
    method: 'GET',
    params: params
  })
}
